import { containsIgnoreCase } from '@dte/otw-utils-core/src/strings/equalsIgnoreCase';

const OutageCallCodes = [
	'MOMENTARY',
	'AMI_XCURR',
	'ONELEG',
	'XCURR',
	'PRIMARY',
	'EHS',
	'HIC',
	'HOSP',
	'SCHOOL',
	'SDXL',
];

export function isOutageCallCode(callCode: string | undefined): boolean {
	return containsIgnoreCase(OutageCallCodes, callCode);
}
